
import SidebarShell from "@/components/SidebarShell/SidebarShell.vue";
import SidebarContext from "@/components/SidebarContext/SidebarContext.vue";
import SidebarUserFooter from "@/components/SidebarUserFooter/SidebarUserFooter.vue";
import brand_details from "@/data/brand_details";
import is_admin_user from "@/utils/auth_user";

// IMPORT UTILITIES
import { get_user_profile } from "@/router";
const details = brand_details();
export default {
  name: "PortfolioSidebar",

  // REGISTER SHARED COMPONENTS
  components: ({
    SidebarShell,
    SidebarContext,
    SidebarUserFooter
  }),

  // PROPS PASSED FROM dashboard_one
  props: {
    tiles: Array,
    current_active_property: String
  },

  data() {
    return ({
      //Brand Information
      brand_name: details.name,
      brand_subtitle: details.subtitle,
      entity_name: details.sub_entity_name,

      // CONTEXT STATE
      selected_portfolio: details.sub_entity_name,
      local_active_property: null,
      active_menu_item: "portfolio-comparisons",
      dropdownOpen: false,
      show_collapsed_properties: false,

      // FOOTER DATA
      full_name: "Guest User",
      initials: "GU",
      is_admin: false,

      // BRAND LOGO
      short_logo: details.logo
    });
  },

  // COMPUTED VALUES
  computed: ({
    total_properties_count() {
      return (this.tiles || []).length;
    },

    portfolio_context_subtitle() {
      return `Executive View`;
    },

    tilesFormatted() {
      return (this.tiles || []).map(t => ({
        id: t.id,
        label: t.title,
        icon: t.icon || "bi bi-building" // fallback icon
      }));
    },

    menuItems() {
      return [
        { key: "portfolio-comparisons", label: "Portfolio Comparisons", icon: "bi bi-bar-chart-line" },
        // { key: "executive-summary", label: "Executive Summary", icon: "bi bi-pie-chart-fill" },
        { key: "esg-sustainability", label: "ESG & Sustainability", icon: "bi bi-leaf-fill" },
        // { key: "financial-performance", label: "Financial Performance", icon: "bi bi-cash-stack" },
        { key: "fungi-profit-share", label: "Fungi Profit Share", icon: "bi bi-pie-chart-fill" }
      ];
    }
  }),

  // LIFECYCLE
  mounted() {
    this.load_user_name();

    if (this.current_active_property) {
      this.local_active_property = this.current_active_property;
      this.selected_portfolio = this.current_active_property;
    }
  },

  // METHODS
  methods: {
    /** FOOTER NAME / INITIALS */
    load_user_name() {
      const user = get_user_profile();
      let name = "Guest User";
      this.is_admin = is_admin_user(user);

      if (user && (user.first_name || user.last_name)) {
        name = `${user.first_name || ""} ${user.last_name || ""}`.trim();
      } else {
        const first = sessionStorage.getItem("first_name") || "";
        const last = sessionStorage.getItem("last_name") || "";
        name = `${first} ${last}`.trim() || "Guest User";
      }

      if (name === "Guest User" && user?.email) {
        name = user.email.split("@")[0];
      }

      const parts = name.split(" ");
      const initials = ((parts[0]?.[0] || "") + (parts[1]?.[0] || "")).toUpperCase();

      this.full_name = name;
      this.initials = initials || "GU";
    },

    /** CONTEXT DROPDOWN ACTIONS */
    toggleDropdown() {
      this.dropdownOpen = !this.dropdownOpen;
    },

    select_global_portfolio() {
      this.selected_portfolio = "Global Portfolio";
      this.local_active_property = null;
      this.active_menu_item = "portfolio-comparisons";
      this.dropdownOpen = false;

      this.$emit("global-selected");
      this.$emit("global-menu-selected", "portfolio-comparisons");
    },

    select_tile_directly(tile) {
      this.selected_portfolio = tile.label;
      this.local_active_property = tile.label;
      this.active_menu_item = "portfolio-comparisons";
      this.dropdownOpen = false;

      this.$emit("tile-clicked", tile.id);
    },

    /** MENU SELECTION */
    select_menu_item(menuItem) {
      this.active_menu_item = menuItem;
      this.dropdownOpen = false;

      if (!this.local_active_property) {
        this.$emit("global-menu-selected", menuItem);
        return;
      }

      const tile = this.tiles.find(t => t.title === this.local_active_property);

      if (tile) {
        this.$emit("property-menu-selected", {
          menuItem,
          propertyId: tile.id,
          propertyName: tile.title
        });
      } else {
        this.$emit("global-menu-selected", menuItem);
      }
    },
    toggle_collapsed_properties() {
      this.show_collapsed_properties = !this.show_collapsed_properties;
    }

  }
};
